import { BrowserModule } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FileUploadModule } from 'ng2-file-upload';
import {CdkTableModule} from '@angular/cdk/table';
import { ChartModule } from 'angular2-chartjs';
import { LayoutModule } from '@angular/cdk/layout'
import { FlexLayoutModule } from '@angular/flex-layout';
import { MomentModule } from 'ngx-moment';

import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';

import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule, MatNativeDateModule } from '@angular/material';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatFileUploadModule } from 'angular-material-fileupload';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatRadioModule} from '@angular/material/radio';
import {MatDividerModule} from '@angular/material/divider';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent, dialog_forget, dialog_notify, dialog_consent } from './login/login.component';
import { SeleteHospitalComponent } from './selete-hospital/selete-hospital.component';
import { MainComponent, dialog_reset_password } from './main/main.component';
import { UploadComponent } from './main/upload/upload.component';
import { HistoryComponent, dialog_delete, dialog_view, dialog_export } from './main/history/history.component';
import { HospitalComponent } from './main/hospital/hospital.component';
import { DisplayComponent, dialog_view_picture } from './main/display/display.component';
import { TestComponent, dialog_test } from './test/test.component';
import { MangementComponent } from './main/mangement/mangement.component';
import { EmployeeComponent, dialog_add_employee, dialog_edit_employee, dialog_delete_employee, dialog_forget_password, dialog_select_delete } from './main/mangement/employee/employee.component';
import { PackageComponent, dialog_add_package, dialog_edit_package, dialog_delete_package } from './main/mangement/package/package.component';
import { HospitalCreateComponent, dialog_add_hospital, dialog_edit_hospital, dialog_delete_hospital } from './main/mangement/hospital-create/hospital-create.component';
import { ApiComponent, dialog_add_api, dialog_edit_api, dialog_delete_api } from './main/mangement/api/api.component';
import { HistoryHospitalComponent } from './main/mangement/history-hospital/history-hospital.component';
import { AnnounccmentComponent, dialog_addAnnouncement, dialog_edit_announcement } from './main/mangement/announccment/announccment.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SeleteHospitalComponent,
    MainComponent,
    UploadComponent,
    HistoryComponent,
    HospitalComponent,
    DisplayComponent,
    dialog_delete,
    dialog_view,
    dialog_view_picture,
    dialog_add_employee,
    dialog_edit_employee,
    dialog_delete_employee,
    dialog_add_package,
    dialog_edit_package,
    dialog_delete_package,
    dialog_add_hospital,
    dialog_edit_hospital,
    dialog_delete_hospital,
    dialog_export,
    dialog_reset_password,
    dialog_forget,
    TestComponent,
    dialog_forget_password,
    dialog_add_api,
    dialog_edit_api,
    dialog_delete_api,
    dialog_select_delete,
    dialog_test,
    dialog_notify,
    dialog_consent,
    dialog_addAnnouncement,
    dialog_edit_announcement,
    MangementComponent,
    EmployeeComponent,
    PackageComponent,
    HospitalCreateComponent,
    ApiComponent,
    HistoryHospitalComponent,
    AnnounccmentComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    LayoutModule,
    MomentModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatMenuModule,
    MatTabsModule,
    MatTableModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatStepperModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatFileUploadModule,
    FileUploadModule,
    MatSortModule,
    MatCheckboxModule,
    CdkTableModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    ChartModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule ,
    MatDividerModule,
    FlexLayoutModule
  ],
  entryComponents: [
    dialog_delete,
    dialog_view,
    dialog_view_picture,
    dialog_add_employee,
    dialog_edit_employee,
    dialog_delete_employee,
    dialog_add_package,
    dialog_edit_package,
    dialog_delete_package,
    dialog_add_hospital,
    dialog_edit_hospital,
    dialog_delete_hospital,
    dialog_export,
    dialog_reset_password,
    dialog_forget,
    dialog_forget_password,
    dialog_add_api,
    dialog_edit_api,
    dialog_delete_api,
    dialog_select_delete,
    dialog_test,
    dialog_notify,
    dialog_consent,
    dialog_addAnnouncement,
    dialog_edit_announcement,
  ],
  providers: [DatePipe, MatDatepickerModule, MatNativeDateModule],
  bootstrap: [AppComponent]
})
export class AppModule { }
